import { composer } from '../../../../../component-decorators/composer';
import s from '../solution-rate-reviews.scss';
import React from 'react';
import { StarFilled } from '@wix/wix-ui-icons-common';
import { RateCharts } from './solution-rate-charts';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Heading, Box, Text } from '@wix/design-system';
import type { ISolutionReviewsDTO } from '../../../../../types/common/marketplace';

export const dtoToSolutionRateProps = (
  reviewsDto: ISolutionReviewsDTO,
): ISolutionRateProps => {
  return {
    ratingHistogram: reviewsDto.body.ratingHistogram,
    reviewStars: reviewsDto.body.averageRating,
    numberOfReviews: reviewsDto.body.totalReviews,
  };
};
export interface ISolutionRateProps extends Partial<WithTranslationProps> {
  numberOfReviews: number;
  ratingHistogram: {
    rating1: number;
    rating2: number;
    rating3: number;
    rating4: number;
    rating5: number;
  };
  reviewStars: number;
}

export const SolutionRate = composer()
  .withTranslation()
  .compose((props: ISolutionRateProps) => {
    return (
      <div className={s.solutionRatingCotainer}>
        <div className={s.rateTitle}>
          <div>
            <Box
              direction="horizontal"
              className={s.ratingMainTitle}
              verticalAlign="middle"
            >
              <StarFilled size="28" color="#FDB10C" />
              <Heading
                className={s.avgRating}
                appearance="H2"
                dataHook="solution-average-rating"
              >
                {props.t('solution.page.avgRating', {
                  rating: props.reviewStars?.toFixed(1),
                })}
              </Heading>
            </Box>
            <Box marginTop="6px" marginLeft="24px">
              <Text
                size="medium"
                weight="thin"
                secondary
                dataHook="solution-based-on-reviews"
              >
                {props.t('solution.page.basedOn', {
                  rateCount: props.numberOfReviews,
                })}
              </Text>
            </Box>
          </div>
        </div>
        <div className={s.rateMeter}>
          <RateCharts
            totalCount={props.numberOfReviews}
            {...props.ratingHistogram}
          />
        </div>
      </div>
    );
  });
